import styles from './Countdown.module.scss';
import classNames from 'classnames';
import { Paragraph } from 'ui/components';
import { useEffect, useState } from 'react';

export interface CountdownProps {
	className?: string;
	date?: string;
}

interface TimeLeft {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
}

const getTargetDate = (date?: string): Date => {
	if (date) return new Date(date.replace(' ', 'T'));
	const year = new Date().getFullYear();
	return new Date(`${year}-11-15T09:30:00`);
};

const calculateTimeLeft = (date?: string): TimeLeft => {
	const diff = getTargetDate(date).valueOf() - Date.now();
	return {
		days: Math.floor(diff / 1000 / 60 / 60 / 24),
		hours: Math.floor(diff / 1000 / 60 / 60) % 24,
		minutes: Math.floor(diff / 1000 / 60) % 60,
		seconds: Math.floor(diff / 1000) % 60,
	};
};

export const Countdown: React.FC<CountdownProps> = ({ className, date }) => {
	const [time, setTime] = useState<TimeLeft>(() => calculateTimeLeft(date));

	useEffect(() => {
		setTime(calculateTimeLeft(date));
		const id = setInterval(() => setTime(calculateTimeLeft(date)), 1000);
		return () => clearInterval(id);
	}, [date]);

	return (
		<article id="countdown" className={classNames(styles.Countdown, className)}>
			<Paragraph className={styles.Countdown_Headline}>Er du klar?</Paragraph>
			<div className={styles.Countdown_Wrapper}>
				<div className={styles.Countdown_Time}>
					<h2 className={styles.Countdown_Digits}>{time.days}</h2>
					<small className={styles.Countdown_Text}>Dage</small>
				</div>

				<div className={styles.Countdown_Time}>
					<h2 className={styles.Countdown_Digits}>{time.hours}</h2>
					<small className={styles.Countdown_Text}>Timer</small>
				</div>

				<div className={styles.Countdown_Time}>
					<h2 className={styles.Countdown_Digits}>{time.minutes}</h2>
					<small className={styles.Countdown_Text}>Minutter</small>
				</div>

				<div className={styles.Countdown_Time}>
					<h2 className={styles.Countdown_Digits}>{time.seconds}</h2>
					<small className={styles.Countdown_Text}>Sekunder</small>
				</div>
			</div>
		</article>
	);
};
